import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Beratung = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const leistungen = [
    'Beratungseinsätze nach § 37 SGB XI',
    'Pflegeberatung für Angehörige',
    'Hilfe bei Antragstellungen (Pflegegrad, Versorgungsamt)',
    'Kostenübernahmeberatung',
    'Information über Pflegeleistungen',
    'Beratung zu Hilfsmitteln',
    'Entlastungsangebote für pflegende Angehörige'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-turquoise-50 to-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 px-4 overflow-hidden" data-testid="beratung-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-turquoise-400 to-turquoise-300 opacity-10"></div>
        <div className="container mx-auto text-center relative z-10">
          <div className="text-6xl mb-6">📋</div>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Beratung & Service
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Kompetente Beratung für alle Fragen rund um die Pflege
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Beratungseinsätze nach § 37 SGB XI
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Sie werden von einem Angehörigen gepflegt und beziehen Pflegegeld? Je nach Pflegegrad müssen Sie in regelmäßigen Abständen einen Beratungseinsatz nach SGB XI § 37 in Anspruch nehmen – Wir beraten Sie umfassend und professionell!
            </p>

            <div className="bg-gradient-to-br from-turquoise-50 to-turquoise-100 rounded-2xl p-6 mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Pflichtberatung bei Pflegegeld
              </h3>
              <p className="text-gray-700 mb-4">
                Wenn Sie Pflegegeld beziehen und von Angehörigen gepflegt werden, sind folgende Beratungseinsätze Pflicht:
              </p>
              <ul className="space-y-2 text-gray-700">
                <li><strong>Pflegegrad 2 und 3:</strong> Halbjährlich (alle 6 Monate)</li>
                <li><strong>Pflegegrad 4 und 5:</strong> Vierteljährlich (alle 3 Monate)</li>
              </ul>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Unsere Beratungsleistungen:
            </h3>
            <ul className="space-y-3 mb-8">
              {leistungen.map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-turquoise-400 mr-3 mt-1">✓</span>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>

            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-6 mt-8 border-l-4 border-orange-400">
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Wichtig zu wissen
              </h3>
              <p className="text-gray-700">
                Die Kosten für die Pflichtberatung nach § 37 SGB XI werden vollständig von der Pflegekasse übernommen. Die Beratung findet bei Ihnen zu Hause statt und dient der Qualitätssicherung der häuslichen Pflege.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-gradient-to-br from-turquoise-400 to-turquoise-500 text-white">
        <div className="container mx-auto text-center max-w-4xl">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Beratungstermin vereinbaren
          </h2>
          <p className="text-xl mb-8">
            Wir beraten Sie gerne – kostenlos und unverbindlich
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/angebot"
              className="bg-white text-turquoise-500 px-8 py-4 rounded-full text-lg font-semibold hover:bg-turquoise-50 transition-all shadow-lg"
              data-testid="beratung-angebot-btn"
            >
              Termin anfragen
            </Link>
            <a 
              href="tel:034124927833"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-turquoise-500 transition-all"
            >
              Jetzt anrufen
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Beratung;
